/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Question sample image with a name to form expressions like 'Sample of {title}'
 * @export
 * @interface PaxCheckQuestionSampleImage
 */
export interface PaxCheckQuestionSampleImage {
    /**
     * Image URL for a sample image to go with the question
     * @type {string}
     * @memberof PaxCheckQuestionSampleImage
     */
    url: string;
    /**
     * Optional title
     * @type {string}
     * @memberof PaxCheckQuestionSampleImage
     */
    title?: string | null;
}

/**
 * Check if a given object implements the PaxCheckQuestionSampleImage interface.
 */
export function instanceOfPaxCheckQuestionSampleImage(value: object): value is PaxCheckQuestionSampleImage {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function PaxCheckQuestionSampleImageFromJSON(json: any): PaxCheckQuestionSampleImage {
    return PaxCheckQuestionSampleImageFromJSONTyped(json, false);
}

export function PaxCheckQuestionSampleImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckQuestionSampleImage {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function PaxCheckQuestionSampleImageToJSON(json: any): PaxCheckQuestionSampleImage {
    return PaxCheckQuestionSampleImageToJSONTyped(json, false);
}

export function PaxCheckQuestionSampleImageToJSONTyped(value?: PaxCheckQuestionSampleImage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'title': value['title'],
    };
}

